import {
  AlertTriangle, BarChart3, Building2, CheckSquare, Layers, Megaphone, Monitor,
  Receipt, Users,
} from "lucide-react";

const ICONS = {
  monitor: Monitor,
  users: Users,
  receipt: Receipt,
  building: Building2,
  "bar-chart": BarChart3,
  megaphone: Megaphone,
  layers: Layers,
  alert: AlertTriangle,
  tickets: CheckSquare,
};

/** The icon a provider names in its configuration, or a neutral one if it names nothing. */
export const ProviderIcon = ({ name, className = "h-6 w-6" }) => {
  const Icon = ICONS[name] || Layers;
  return <Icon className={className} aria-hidden="true" />;
};
